import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewContainerRef,
} from '@angular/core';
import filter from '!!file-loader!./assets/filter.svg';
import { PageScrollingService } from '@shared/services/page-scrolling';

@Component({
  selector: 'app-mobile-filters-modal',
  templateUrl: './mobile-filters-modal.component.html',
  styleUrls: ['./mobile-filters-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileFiltersModalComponent implements OnDestroy {
  constructor(private pageScrolling: PageScrollingService) {}

  @Input() container: ViewContainerRef | undefined;
  @Output() closeModal = new EventEmitter();

  filter: string = filter;

  closeFiltersModal(): void {
    this.closeModal.emit();
  }

  closeFiltersWithScrollTo(): void {
    this.closeFiltersModal();
    window.scrollTo(0, 0);
  }

  ngOnDestroy(): void {
    this.pageScrolling.togglePageScroll(false);
  }
}
